module.exports = __webpack_public_path__ + "img/setting.e2a0cdf4.svg";